import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import { ReactComponent as SearchIcon } from "../../assets/icons/marketing/greenSearch.svg";
import { ReactComponent as ClickIcon } from "../../assets/icons/marketing/greenClick.svg";
import { ReactComponent as MessageIcon } from "../../assets/icons/marketing/greenMessage.svg";
import { ReactComponent as ClockIcon } from "../../assets/icons/marketing/greenClock.svg";
import { ReactComponent as Check } from "../../assets/icons/benefitCheck.svg";
import AnimatedTextButton from "../generic/AnimatedTextButton";
import { useNavigate } from "react-router-dom";

const FirebaseBenefits = () => {
  const navigate = useNavigate();

  return (
    <FullPageContainer>
      <Container>
        <Content>
          <TextWrapper>
            <Title>What You Get with Grovs</Title>
            <Subtitle>
              Seamless deep linking, smart attribution, and built-in engagement
              tools—all in one platform. Grovs helps you drive installs, improve
              onboarding, and eliminate drop-offs with frictionless user
              journeys.
            </Subtitle>
            <Subtitle>
              <AnimatedTextButton
                light="light"
                style={{
                  color: lightThemeColors.lightColor,
                  borderBottom: `1px solid ${lightThemeColors.lightColor}`,
                  fontWeight: "600",
                }}
                text={"Explore Grovs engagement"}
                onClick={() => navigate("/engagement")}
              />
            </Subtitle>
          </TextWrapper>
          <RightSide>
            <ContentBox>
              <BoxItem>
                <Check /> <p>Smart, branded links</p>
              </BoxItem>
              <BoxItem>
                <Check /> <p>Deferred deep linking</p>
              </BoxItem>
              <BoxItem>
                <Check /> <p>First-party attribution</p>
              </BoxItem>
              <BoxItem>
                <Check /> <p>Link-level analytics</p>
              </BoxItem>
              <BoxItem>
                <Check /> <p>Custom domains</p>
              </BoxItem>
              <BoxItem>
                <Check /> <p>SDKs for iOS, Android, and Web</p>
              </BoxItem>
              <BoxItem>
                <Check /> <p>Easy onboarding & full documentation</p>
              </BoxItem>
            </ContentBox>
          </RightSide>
        </Content>
      </Container>
    </FullPageContainer>
  );
};

export default FirebaseBenefits;

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.darkColor};
  position: relative;
  color: ${lightThemeColors.lightColor};
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
  padding: 100px 80px;
  gap: 100px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
  color: ${lightThemeColors.lightColor};
`;
const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 80px;
  align-items: center;
  @media (max-width: 990px) {
    flex-direction: column;
  }
  color: ${lightThemeColors.lightColor};
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 30px;
  color: ${lightThemeColors.lightColor};
`;

const Title = styled.h1`
  color: ${lightThemeColors.darkColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
  color: ${lightThemeColors.lightColor};
`;
const Subtitle = styled.p`
  color: ${lightThemeColors.darkColorFaded};
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  @media (max-width: 990px) {
    font-size: 18px;
    line-height: 24px;
    text-align: center;
  }
  color: ${lightThemeColors.lightColor};
`;

const RightSide = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  gap: 10px;
  overflow: hidden;
  color: ${lightThemeColors.lightColor};
`;
const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 30px 20px;
  border-radius: 10px;
  border: 1px solid rgba(237, 235, 234, 0.11);
  width: 100%;
  color: ${lightThemeColors.lightColor};
`;
const BoxItem = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  p {
    color: ${lightThemeColors.darkColor};
    font-weight: 600;
    font-size: 20px;
    line-height: 26px;
    color: ${lightThemeColors.lightColor};
  }
  svg {
    height: 35px;
    width: 35px;
  }
`;
